import type { FC } from "react"
import React from "react"
import { ErrorBoundary } from "../ErrorBoundary"
import style from "./UserNotAllowed.module.scss"

export const UserNotAllowed: FC = () => {
  return (
    <ErrorBoundary
      reload={false}
      error={new Error("User not allowed")}
      title="Utente non autorizzato"
      message={
        <>
          <p className={style.detail}>Non ci risulta che abbia accesso alla piattaforma clienti Banca CF+.</p>
          <p className={style.detail}>
            Se credi sia un errore, contattaci al{" "}
            <a className={style.link} href="tel:+39800938874">
              800938874
            </a>{" "}
            oppure scrivi una mail a{" "}
            <a className={style.link} href="mailto:partner@bancacfplus.it">
              partner@bancacfplus.it
            </a>
            .
          </p>
        </>
      }
    />
  )
}
